export const FEATURE_FLAG = {
    QuippyPackActions: 'quippy-pack-actions',
    DocumentPackSuggestions: 'document-pack-suggestions',
    PackApprovals: 'pack-approvals',
    AppTopBar: 'app-top-bar',
    BuildingIntelligence: 'building-intelligence',
    BuildingIntelligenceDocument: 'building-intelligence-document',
    BuildingAccessRequests: 'building-access-requests',
    BuildingIdentificationNumbers: 'building-identification-numbers',
    BuildingAddressContext: 'building-address-context',
    BuildingDocumentReenrichment: 'building-document-reenrichment',
    BuildingHostContext: 'building-host-context',
    BuildingSustainabilityDatapoints: 'building-sustainability-datapoints',
    GoogleDriveImport: 'google-drive-import',
    ProcoreImport: 'procore-import',
    _Placeholder: 'placeholder',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];
export type RuntimeFeatureFlag = Exclude<
    FeatureFlag,
    typeof FEATURE_FLAG._Placeholder
>;

export const RUNTIME_FEATURE_FLAGS = Object.values(FEATURE_FLAG).filter(
    (flag): flag is RuntimeFeatureFlag => flag !== FEATURE_FLAG._Placeholder
);

export interface FeatureFlagState {
    flag: RuntimeFeatureFlag;
    defaultValue: boolean;
    overrideValue: boolean | null;
    effectiveValue: boolean;
}
